import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

export default function Footer() {
  const scrollToTop = () => window.scrollTo(0, 0);

  return (
    <footer className="bg-slate-950 text-slate-400 pt-20 pb-10 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <Link to="/" onClick={scrollToTop}><Logo light={true} /></Link>
            <p className="mt-6 text-sm leading-relaxed pr-8">
              Eldenwyck & Co. is a premier global consulting firm partnering with leaders in business and society to tackle their most important challenges.
            </p>
            <div className="flex gap-4 mt-8">
              {['FiLinkedin', 'FiTwitter', 'FiYoutube'].map((icon, i) => (
                <a key={i} href="#" className="w-10 h-10 flex items-center justify-center border border-slate-800 hover:border-amber-500 hover:text-amber-500 transition-colors">
                  <SafeIcon name={icon} className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-serif font-semibold mb-6">Services</h4>
            <ul className="space-y-3 text-sm">
              {['Strategy', 'Digital', 'Operations', 'M&A', 'Sustainability'].map(item => (
                <li key={item}><Link to="/#services" className="hover:text-amber-500 transition-colors">{item}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-serif font-semibold mb-6">Company</h4>
            <ul className="space-y-3 text-sm">
              {['About Us', 'Leadership', 'Careers', 'Locations'].map(item => (
                <li key={item}><Link to="/#about" className="hover:text-amber-500 transition-colors">{item}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-serif font-semibold mb-6">Legal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/legal/privacy" onClick={scrollToTop} className="hover:text-amber-500 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal/terms" onClick={scrollToTop} className="hover:text-amber-500 transition-colors">Terms of Use</Link></li>
              <li><Link to="/legal/cookies" onClick={scrollToTop} className="hover:text-amber-500 transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-xs">
          <p>&copy; {new Date().getFullYear()} Eldenwyck & Company. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}